import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { AuthStateSignalsService } from '../../../services/auth-state-signals.service';
import { UserRole } from '../../../shared/utils/user-roles.enum';
import { MatToolbar } from '@angular/material/toolbar';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatToolbar,
        MatMenuTrigger,
        MatIcon,
        MatMenu,
        MatMenuItem,
        RouterLink,
    ],
})
export class HeaderComponent {
  protected readonly authService = inject(AuthStateSignalsService);

  protected getRoleDisplayName(role: UserRole): string {
    const roleMap: Record<UserRole, string> = {
      [UserRole.CommitteeMember]: 'Committee Member',
      [UserRole.CommitteeDelegate]: 'Committee Member Delegate',
      [UserRole.ComplianceOfficer]: 'Compliance Officer',
      [UserRole.LpgCoordinator]: 'LPG Coordinator',
      [UserRole.TcoBiddingSupport]: 'Support Member',
    };

    return roleMap[role] || role;
  }

  protected logout(): void {
    this.authService.signOut().subscribe({
      next: () => {},
      error: (error) => {
        console.error('Sign out failed:', error);
      },
    });
  }
}
